import { useAsyncState } from '@vueuse/core'

import type { TemplateAllPayload } from './useFetchTemplate'

import { useFetchTemplate } from './useFetchTemplate'
import { setDefaultApiResponseWithMeta } from '../useInternalApi'

const byId = (id: MaybeRef<string>) => {
  const { getById } = useFetchTemplate()
  return useAsyncState(() => getById({ id: unref(id) }), undefined)
}

const all = (payload: MaybeRef<TemplateAllPayload>) => {
  const { getAll } = useFetchTemplate()
  return useAsyncState(() => getAll({ payload: unref(payload) }), setDefaultApiResponseWithMeta())
}

export const useQueryTemplate = {
  all,
  byId,
}
